export enum REVIEW_PAGE_COLUMN {
  CHECK_BOX = 'checkBox',
  ASSEMBLY_NAME = 'assemblyName',
  CHANNEL_TYPE = 'channelType',
  NO_OF_LOCATION_GROUPS = 'noOfLocationGroups',
  STATE = 'state',
  TAGS = 'tags',
  TOGGLE = 'toggle',
}
